import * as React from "react";
import { IdStyles } from "../../../../less/IdStyles";
import { utilBuff } from "../../../../utils/utilBuff";
import { utilEvent } from "../../../../utils/utilEvent";
import { DiscountEventTimer } from "../../../discount-event/DiscountEventTimer";
import { Badge } from "../../../generic/badge/Badge";
import { IdBadgePosition } from "../../../generic/badge/IdBadgePosition";
import { BuildingUpgradeNew } from "./BuildingUpgradeNew";
import { BuildingUpgradeOld } from "./BuildingUpgradeOld";
import { BuildingUpgradeRequirements } from "./BuildingUpgradeRequirements";
import { ButtonUpgradeBuilding } from "./ButtonUpgradeBuilding";
export var BuildingUpgrade = function (_a) {
    var currentStage = _a.currentStage, nextStage = _a.nextStage, building = _a.building, constructionTime = _a.constructionTime, onInfoButton = _a.onInfoButton, levelLockStandard = _a.levelLockStandard, onUpgradeGold = _a.onUpgradeGold, onUpgradeResources = _a.onUpgradeResources, discountEvent = _a.discountEvent, discountPremiumBuff = _a.discountPremiumBuff;
    var discountBadge;
    if (discountPremiumBuff && discountEvent) {
        var discountEndTime = utilEvent.getEndTime(discountEvent);
        var discountPercentage = utilBuff.factorMultiplicationToPercentage(discountPremiumBuff.factorMultiplication);
        discountBadge = (React.createElement(Badge, { position: IdBadgePosition.TopLeft },
            React.createElement(DiscountEventTimer, { discountAmount: discountPercentage, endTime: discountEndTime })));
    }
    return (React.createElement("div", { className: "building-upgrade" },
        discountBadge,
        React.createElement("div", { className: "building-upgrade__content-wrapper" },
            React.createElement("div", { className: "building-upgrade__content" },
                React.createElement(BuildingUpgradeOld, { currentStage: currentStage, nextStage: nextStage, building: building, constructionTime: constructionTime, onInfoButton: onInfoButton }),
                React.createElement(BuildingUpgradeNew, { currentStage: currentStage, nextStage: nextStage, building: building, constructionTime: constructionTime }, levelLockStandard && (React.createElement("div", { className: "building-upgrade__new-disabled " + IdStyles.BuildingUpgradeRequirementDisabled },
                    React.createElement("div", { className: IdStyles.TextBoldSecondary }, levelLockStandard.message)))))),
        React.createElement(BuildingUpgradeRequirements, { currentStage: currentStage, nextStage: nextStage }),
        React.createElement(ButtonUpgradeBuilding, { building: building, onUpgradeGold: onUpgradeGold, onUpgradeResources: onUpgradeResources, stage: nextStage })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/upgrade/BuildingUpgrade.tsx
// module id = 2859
// module chunks = 3